import { EditCalendar, QrCode } from "@mui/icons-material";
import { Avatar, Box, IconButton, Typography } from "@mui/material";
import { HbType } from "../../utils/ConstType";
import Constants from "../../utils/Constants";
import EfStyleSheet from "../../utils/style-helper";
import Utils from "../../utils/utils";
import FallbackImageView from "../fallback-image-view";

export default function ManualAttendanceListItem({
  attendance,
  onEdit,
}: {
  attendance: HbType.AttendanceResponseType;
  onEdit: ((attendance: HbType.AttendanceResponseType) => void) | null;
}) {
  const styles = EfStyleSheet.create({
    root: {
      flexWrap: "wrap",
      mt: 1,
      mb: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      p: 1,
      borderRadius: 2,
      backgroundColor:
        (attendance.status === "present"
          ? Constants.colors.lightTheme.palette.success.main
          : attendance.status === "late"
          ? Constants.colors.lightTheme.palette.warning.main
          : attendance.status === "skipped"
          ? Constants.colors.lightTheme.palette.text.secondary
          : Constants.colors.lightTheme.palette.error.main) + "10",
      "&:hover": {
        backgroundColor:
          (attendance.status === "present"
            ? Constants.colors.lightTheme.palette.success.main
            : attendance.status === "late"
            ? Constants.colors.lightTheme.palette.warning.main
            : attendance.status === "skipped"
            ? Constants.colors.lightTheme.palette.text.secondary
            : Constants.colors.lightTheme.palette.error.main) + "30",
      },
    },
    avatar: {
      backgroundColor:
        Constants.colors.lightTheme.palette.secondary.main + "80",
    },
    center: {
      flexGrow: 1,
    },
    action: {
      height: "100%",
      display: "flex",
      flexGrow: 1,
      alignItems: "center",
      justifyContent: "flex-end",
    },
    status: {
      width: "fit-content",
      padding: "2px 8px",
      borderRadius: 4,
      color: "white",
      fontWeight: "bold",
      textTransform: "capitalize",
      fontSize: 10,
      backgroundColor:
        attendance.status === "present"
          ? Constants.colors.lightTheme.palette.success.main
          : attendance.status === "late"
          ? Constants.colors.lightTheme.palette.warning.main
          : attendance.status === "skipped"
          ? Constants.colors.lightTheme.palette.text.secondary
          : Constants.colors.lightTheme.palette.error.main,
    },
    detentioned: {
      width: "fit-content",
      padding: "2px 8px",
      borderRadius: 4,
      color: "white",
      fontWeight: "bold",
      textTransform: "capitalize",
      fontSize: 10,
      display: attendance.status === "absent" ? "none" : "flex",
      backgroundColor:
        attendance.detentioned === "yes"
          ? Constants.colors.lightTheme.palette.error.main
          : Constants.colors.lightTheme.palette.success.main,
    },
  });
  return (
    <Box sx={styles.root}>
      <Box>
        <Avatar sx={styles.avatar}>
          <FallbackImageView
            src={Utils.retrieveImageURL(attendance.student.profile_url)}
            fallback={Constants.images.student}
          />
        </Avatar>
      </Box>
      <Box sx={styles.center}>
        <Typography
          variant="h6"
          sx={{ color: Constants.colors.lightTheme.palette.primary.main }}
        >
          {attendance.student.first_name}{" "} {attendance.student.middle_name}{" "} {attendance.student.last_name}
          <span style={{ fontSize: 10 }}> - {attendance.query_time}</span>
        </Typography>
        <Box
          display="flex"
          gap={1}
          alignItems="center"
          justifyContent="flex-start"
          flexWrap="wrap"
        >
          {attendance.present_by === "qr" && <QrCode sx={{ fontSize: 18 }} />}
          <Typography sx={styles.status}>{attendance.status}</Typography>
          {attendance.detentioned === "yes" && (
            <Typography sx={styles.detentioned}>Detentioned</Typography>
          )}
        </Box>
      </Box>

      <Box sx={styles.action}>
        {onEdit && (
          <IconButton
            color="primary"
            size="large"
            onClick={() => {
              onEdit(attendance);
            }}
          >
            <EditCalendar />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
